import { render } from "./UnitInfoPanel.vue?vue&type=template&id=4672f71e&scoped=true"
import script from "./UnitInfoPanel.vue?vue&type=script&lang=js"
export * from "./UnitInfoPanel.vue?vue&type=script&lang=js"

import "./UnitInfoPanel.vue?vue&type=style&index=0&id=4672f71e&scoped=true&lang=css"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\Super Tactico - Official App\\Online - Routed\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4672f71e"]])

export default __exports__